import { render, staticRenderFns } from "./dateRegion.vue?vue&type=template&id=45c4af49&"
import script from "./dateRegion.vue?vue&type=script&lang=js&"
export * from "./dateRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports